import type { ReactNode } from 'react';

export const symbol_bookmark_added: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m716-690 127-127q8.8-9 20.9-9 12.1 0 21.1 9.05 9 9.06 9 21.5 0 12.45-9 21.45L737-626q-9 9-21 9t-21-9l-64-64q-9-9-9-21.16t8.61-21Q640-741 652.47-741q12.46 0 21.53 9l42 42ZM480-240l-196 84q-30 13-57-4.76-27-17.75-27-50.24v-574q0-24 18-42t42-18h260q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H260v574l220-93 220 93v-304q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v304q0 32.49-27 50.24Q706-143 676-156l-196-84Zm0-545H260h290-70Z"
		/>
	</svg>
);
